import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { ICustomLogField } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class CustomLogFieldService extends BaseService<ICustomLogField> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'customLogField');
  }
}

export { ICustomLogField } from '../shared/api';
